(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('redux')) :
    typeof define === 'function' && define.amd ? define(['exports', 'redux'], factory) :
    (factory((global.restate = {}),global.redux));
}(this, (function (exports,redux) { 'use strict';

    function getType(actionCreator) {
        if (actionCreator == null) {
            throw new Error('first argument is missing');
        }
        if (actionCreator.getType == null) {
            throw new Error('first argument is not an instance of "typesafe-actions"');
        }
        return actionCreator.getType();
    }

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    function attachGetType(ac, actionType) {
        ac.getType = function () { return actionType; };
        return ac;
    }
    function buildAction(actionType) {
        if (actionType == null) {
            throw new Error('first argument is missing');
        }
        else {
            if (typeof actionType !== 'string' && typeof actionType !== 'symbol') {
                throw new Error('first argument should be type of: string | symbol');
            }
        }
        function createEmpty() {
            var ac = function () { return ({ type: actionType }); };
            return attachGetType(ac, actionType);
        }
        function createPayload() {
            var ac = function (payload) { return ({ type: actionType, payload: payload }); };
            return attachGetType(ac, actionType);
        }
        function createFsa(payloadCreator, metaCreator) {
            var ac = function (payload) { return (__assign({ type: actionType }, { payload: payloadCreator != null ? payloadCreator(payload) : undefined }, { meta: metaCreator != null ? metaCreator(payload) : undefined })); };
            return attachGetType(ac, actionType);
        }
        function createAsync() {
            var atRequest = actionType + ('_' + 'REQUEST');
            var atSuccess = actionType + ('_' + 'SUCCESS');
            var atFailure = actionType + ('_' + 'FAILURE');
            var acRequest = function (payload) { return (__assign({ type: atRequest }, { payload: payload != null ? payload : undefined })); };
            var acSuccess = function (payload) { return (__assign({ type: atSuccess }, { payload: payload != null ? payload : undefined })); };
            var acFailure = function (payload) { return (__assign({ type: atFailure }, { payload: payload != null ? payload : undefined })); };
            return {
                request: attachGetType(acRequest, atRequest),
                success: attachGetType(acSuccess, atSuccess),
                failure: attachGetType(acFailure, atFailure),
            };
        }
        var actionBuilder = {
            empty: createEmpty,
            payload: createPayload,
            async: createAsync,
            fsa: createFsa,
        };
        return actionBuilder;
    }

    var reducerPathSymbol = Symbol();
    function getProp(object, keys) {
        keys = Array.isArray(keys) ? keys : keys.split(".");
        object = object[keys[0]];
        if (object && keys.length > 1) {
            return getProp(object, keys.slice(1));
        }
        return object;
    }
    function isReducerBuilder(builder) {
        return typeof builder === "object" && Reflect.has(builder, reducerPathSymbol);
    }
    function traverseReducers(reducers, path) {
        for (var key in reducers) {
            var reducer = reducers[key];
            if (isReducerBuilder(reducer)) {
                reducer[reducerPathSymbol] = (path ? path + "." : "") + key;
            }
        }
    }
    var identityWithDefault = function (d) { return function (s) {
        if (s === void 0) { s = d; }
        return s;
    }; };
    function pruneInitialState(initialState) {
        return Object.keys(initialState).reduce(function (acc, el) {
            if (isReducerBuilder(initialState[el])) {
                acc.reducers[el] = initialState[el].buildReducer();
            }
            else {
                acc.defaultState[el] = initialState[el];
                acc.reducers[el] = identityWithDefault(initialState[el]);
            }
            return acc;
        }, { reducers: {}, defaultState: {} });
    }
    var identity = function (d) {
        var _ = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _[_i - 1] = arguments[_i];
        }
        return d;
    };
    function getDefaultReducer(initialState, path) {
        var defaultState = initialState;
        var nestedReducer = identity;
        if (typeof initialState === "object") {
            traverseReducers(initialState, path);
            var res = pruneInitialState(initialState);
            if (Object.keys(res.reducers).length !== 0) {
                //@ts-ignore
                nestedReducer = redux.combineReducers(res.reducers);
            }
            defaultState = res.defaultState;
        }
        return { nestedReducer: nestedReducer, defaultState: defaultState };
    }
    var ReducerBuilder = /** @class */ (function () {
        function ReducerBuilder(initialState) {
            this.initialState = initialState;
            this.handlers = {};
            this[_a] = "";
        }
        ReducerBuilder.prototype.on = function (action, handler) {
            if (action === undefined || action === null) {
                throw new Error("action should be an action, got " + action);
            }
            this.handlers[getType(action)] = handler;
            return this;
        };
        ReducerBuilder.prototype.handle = function (type, handler) {
            var _this = this;
            if (Array.isArray(type)) {
                type.forEach(function (t) { return _this.handle(t, handler); });
            }
            else {
                this.handlers[type] = handler;
            }
            return this;
        };
        ReducerBuilder.prototype.select = function (rs) {
            if (this[reducerPathSymbol]) {
                return getProp(rs, this[reducerPathSymbol]);
            }
            else {
                return rs;
            }
        };
        ReducerBuilder.prototype.buildReducer = function (path) {
            var _this = this;
            if (path) {
                this[reducerPathSymbol] = path;
            }
            var _a = getDefaultReducer(this.initialState, this[reducerPathSymbol] || path), defaultState = _a.defaultState, nestedReducer = _a.nestedReducer;
            return function (state, action) {
                if (state === void 0) { state = defaultState; }
                state = nestedReducer(state, action);
                if (!action) {
                    return state;
                }
                var type = action.type, payload = action.payload, meta = action.meta;
                if (_this.handlers[type]) {
                    var handler = _this.handlers[type];
                    state = handler(state, payload, meta);
                }
                return state;
            };
        };
        return ReducerBuilder;
    }());
    _a = reducerPathSymbol;
    function createState(initialState) {
        if (initialState === undefined) {
            throw new Error("initial state cannot be undefined");
        }
        // @ts-ignore
        return new ReducerBuilder(initialState);
    }
    var a = createState("");
    var b = createState("");
    var c = createState({ a: a, b: b });
    var _a;

    var createAction$1 = function (name) { return buildAction(name).payload(); };
    var build = {
        plain: function (name) {
            return buildAction(name).payload();
        },
        async: function (payload, meta) {
            if (payload === void 0) { payload = function (d) { return d; }; }
            if (meta === void 0) { meta = function (d) { return d; }; }
            return function (name) {
                return buildAction(name).async();
            };
        }
    };
    function createActions(actions, prefix) {
        if (prefix === void 0) { prefix = '@'; }
        //@ts-ignore
        return Object.keys(actions).reduce(function (acc, el) {
            acc[el] = actions[el](prefix + '/' + el);
            return acc;
        }, {});
    }
    function createEffects(actions, prefix) {
        if (prefix === void 0) { prefix = '@'; }
        // @ts-ignore
        return Object.keys(actions).reduce(function (acc, el) {
            acc[el] = actions[el](prefix + '/' + el);
            return acc;
        }, {});
    }

    exports.createState = createState;
    exports.createAction = createAction$1;
    exports.buildAction = buildAction;
    exports.build = build;
    exports.createActions = createActions;
    exports.createEffects = createEffects;

    Object.defineProperty(exports, '__esModule', { value: true });

})));



/*****************
 ** WEBPACK FOOTER
 ** ../~/stateducer/dist/restate.umd.js
 ** module id = 591
 ** module chunks = 3
 **/